/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component, Input } from "@angular/core";
import {
	DataCentersMetricInfoService,
	MetricInfoDefinition,
	MetricInfoKey,
	MetricInfoRange
} from "../../services/data-centers-metric-info.service";

@Component({
	selector: "globalictcc-data-centers-metric-info-dialog",
	standalone: true,
	imports: [],
	templateUrl: "./data-centers-metric-info-dialog.component.html",
	styleUrl: "./data-centers-metric-info-dialog.component.scss"
})
export class DataCentersMetricInfoDialogComponent {
	@Input({ required: true })
	public metricKey!: MetricInfoKey;

	@Input({ required: true })
	public metricInfo!: MetricInfoDefinition;

	constructor(private _metricInfoService: DataCentersMetricInfoService) {}

	public getRangeLabel(range: MetricInfoRange): string {
		return this._metricInfoService.formatRangeLabel(this.metricKey, range);
	}
}
